export const MENU_CATEGORIES_TEST_IDS = {
  categoryName: 'category-name'
};
